import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {LabelConfig} from "../../../../model/channels.model";

@Component({
  selector: 'admin-channels-view-labels',
  templateUrl: './labels.component.html',
  styleUrls: ['./labels.component.css']
})
export class AdminChannelsViewLabelsComponent implements OnChanges {

  @Input() labels?: LabelConfig[];

  labelValues?: LabelConfig[];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['labels']) {
      this.labelValues = this.labels;
    }
  }

}
